module.exports = __webpack_public_path__ + "static/media/6634.8a6686b1.jpg";